<template>
  <div class="handle">
    <v-icon class="drag__icon">mdi-drag</v-icon>
    <h1 class="default__text__title_item"
        v-if="control.value === ''"
    >
      {{ $t('components.questionnaires.inputs.defaultTitle') }}
    </h1>
    <h1 v-if="control.extra === 'main'">{{ control.value }}</h1>
    <h2 v-else>{{ control.value }}</h2>
  </div>
</template>

<script>
import inputMixin from '@/components/questionnaires/fields/inputs/inputMixin'

export default {
  name: 'TitleInput',
  mixins: [inputMixin],
  data () {
    return {
      type: 'title',
      editPanel: 'TitleEditPanel'
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "grab";

  .default__text__title_item {
    font-style: italic;
    font-weight: normal;
  }
</style>
